import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  movieGenre: string;
  movieGenreId: number | null;
};

const initialState: InitialState = {
  movieGenre: "all",
  movieGenreId: null,
};

const movieGenreSlice = createSlice({
  name: "movieGenreSlice",
  initialState,
  reducers: {
    setMovieGenre: (
      state,
      action: PayloadAction<{ movie: string; id: number | null }>
    ) => {
      state.movieGenre = action.payload.movie;
      state.movieGenreId = action.payload.id;
      return state;
    },
    resetMovieGenre:(state,action:PayloadAction)=>{
      state.movieGenre = "all";
      state.movieGenreId = null;
      return state;
    }
  },
});

export const { setMovieGenre,resetMovieGenre } = movieGenreSlice.actions;
export default movieGenreSlice;
